import { format } from 'date-fns'

const DurationDate = ({ dateFrom, dateTo, showYear = true }: { dateFrom: Date; dateTo: Date; showYear?: boolean }) => {
  return (
    <span>
      {dateFrom.getMonth() === dateTo.getMonth() && dateFrom.getFullYear() === dateTo.getFullYear()
        ? format(dateFrom, 'd.')
        : format(dateFrom, 'd. M.')}
      –{format(dateTo, showYear ? 'd. M. yyyy' : 'd. M.')}{' '}
    </span>
  )
}

export default DurationDate
